module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-6.629f42d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-6.jpg
// module id = uDZ3
// module chunks = 1